import { useMemo, useState } from 'react'
import styles from './SimulationSideCard.module.scss'
import { Producer } from 'types/producer'
import ProducerDrawer from 'components/producer-drawer/ProducerDrawer'
import useWindowSize from 'hooks/useWindowSize'
import ProducerSliderLayout from 'components/producer-slider-layout/ProducerSliderLayout'
import SimulationSideCardContent from './SimulationSideCardContent'
import { setSelectedProducer } from 'store/app/slice'
import { useGetProducersQuery } from 'store/api/bolt-api'
import { useStoreDispatch, useStoreSelector } from 'hooks/store'
import { SIMULATION_SIDE_CARD_BREAKPOINT } from './constants'

const SimulationSideCard = () => {
  // Redux store
  const { selectedProducer } = useStoreSelector((store) => store.app)
  const dispatch = useStoreDispatch()
  const { data: producers } = useGetProducersQuery()

  // Window size
  const { isTablet } = useWindowSize(SIMULATION_SIDE_CARD_BREAKPOINT)

  // Local state
  const [showProducerDrawer, setShowProducerDrawer] = useState<boolean>(false)

  // Constants
  const producer = useMemo<Producer>(() => producers?.[selectedProducer], [producers, selectedProducer])

  if (!producer) return null

  return (
    <>
      {!isTablet ? (
        <aside className={styles['container-desktop']}>
          <SimulationSideCardContent openProducerDrawer={() => setShowProducerDrawer(true)} />
        </aside>
      ) : (
        <ProducerSliderLayout producer={producer}>
          <SimulationSideCardContent openProducerDrawer={() => setShowProducerDrawer(true)} />
        </ProducerSliderLayout>
      )}

      <ProducerDrawer
        isOpen={showProducerDrawer}
        onRequestClose={() => setShowProducerDrawer(false)}
        onSelectProducer={(p) => {
          dispatch(setSelectedProducer({ producerSlug: p.slug }))
          setShowProducerDrawer(false)
        }}
      />
    </>
  )
}

export default SimulationSideCard
